export const homeObjOne = {
  lightBg: true,
  lightText: false,
  lightTopLine: true,
  lightTextDesc: false,
  topLine: 'Join ALLDAY VENTURES',
  headline: 'Be part of a movement creating jobs and opportunities',
  description:
    'Join us in building sustainable solutions across agriculture, technology, infrastructure and services.',
  buttonLabel: 'Get Started',
  imgStart: '',
  img: require('../../images/signup.jpg'),
  alt: 'Signup'
};